/**
 * @generated SignedSource<<f41e67404c8e732f337f966c473d764d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ForumOwnerKind = "BLOG" | "COMPETITION" | "DATASET" | "EVENT" | "TOP_LEVEL" | "WORKSPACE";
import { DateTime } from "@/common/relayCustomScalar";
import { FragmentRefs } from "relay-runtime";
export type ForumHelmetFragment$data = {
  readonly createdAt: DateTime;
  readonly forumTopics: {
    readonly nodes: ReadonlyArray<{
      readonly author: {
        readonly displayName: string;
        readonly username: string;
      };
      readonly createdAt: DateTime;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly title: string;
    }>;
  };
  readonly id: string;
  readonly owner: {
    readonly forumOwnerKind: ForumOwnerKind;
    readonly slug: string;
  };
  readonly shortDescription: string;
  readonly slug: string;
  readonly title: string;
  readonly " $fragmentType": "ForumHelmetFragment";
};
export type ForumHelmetFragment$key = {
  readonly " $data"?: ForumHelmetFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ForumHelmetFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ForumHelmetFragment",
  "selections": [
    (v0/*:: as any*/),
    (v1/*:: as any*/),
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "owner",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "forumOwnerKind",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shortDescription",
      "storageKey": null
    },
    (v3/*:: as any*/),
    {
      "alias": "forumTopics",
      "args": [
        {
          "kind": "Literal",
          "name": "last",
          "value": 10
        },
        {
          "kind": "Literal",
          "name": "order",
          "value": "HOT"
        }
      ],
      "concreteType": "TopicConnection",
      "kind": "LinkedField",
      "name": "topics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Topic",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            (v3/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "author",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "username",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "topics(last:10,order:\"HOT\")"
    }
  ],
  "type": "Forum",
  "abstractKey": null
};
})();

(node as any).hash = "1ed6b929d42afcddb7bedd5893760e57";

export default node;
